export default "__VITE_ASSET__CCEtDw9v__"